import React, { useEffect, useRef } from "react";
import "chart.js/auto";
import { Bar } from "react-chartjs-2";

const BarChart = ({ data, options }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // chartRef.current そのものが Chart インスタンス
      const chart = chartRef.current;
      chart.options = options;
      // データを更新したい場合は chart.data に代入
      // chart.data = chartData;
      chart.update();
    }
  }, [options]);

  return <Bar ref={chartRef} data={data} options={options} />;
};

export default BarChart;
